import { AnyAction } from 'redux';
import { ActionTypes } from '../constants/index';
import { Notification } from '../modal';

export default function reducer(state: Notification = new Notification(),
  action: AnyAction) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.NOTIFICATION_LIST_REQUEST:
      return {
        ...state,
        loadingInProgress: true,
      };
    case ActionTypes.NOTIFICATION_LIST_SUCCESS:
      return {
        ...state,
        loadingInProgress: false,
        data: payload,
      };
    case ActionTypes.NOTIFICATION_LIST_ERROR:
      return {
        ...state,
        loadingInProgress: false,
        loadingError: payload,
      };
    default:
      return state;
  }
}
